import type { LeadfunnelConfig } from '@/types';

export const checkForOfficeHours = (openHours: LeadfunnelConfig['openHours']): boolean => {
  const currentDate = new Date();
  const day = currentDate.getDay();
  if (openHours) {
    let parseConfigHours = openHours[day].split('-');
    const dateStart = new Date(
      `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()} ${parseConfigHours[0]}`,
    );
    const dateEnd = new Date(
      `${currentDate.getFullYear()}-${currentDate.getMonth() + 1}-${currentDate.getDate()} ${parseConfigHours[1]}`,
    );
    return dateStart <= currentDate && dateEnd >= currentDate;
  }
  return true;
};

type PrioCalculatorVersion = 0 | 2 | 3;
export const choosePrioCalculatorVersion = (
  v2: LeadfunnelConfig['usePrioCalculatorV2'],
  v3: LeadfunnelConfig['usePrioCalculatorV3'],
): PrioCalculatorVersion => {
  if (v2 === 0 && v3 === 0) return 0;
  return Math.random() <= v2 ? 2 : 3;
};
